var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionPageAccent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1637.843,
    height: 1007.516,
    viewBox: "0 0 1637.843 1007.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .c {\n        stroke-dasharray: 12.922 12.922;\n      }\n\n      .c, .d, .e, .f {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .c, .e, .f {\n        stroke-width: 5px;\n      }\n\n      .g {\n        fill: #c92d6e;\n      }\n\n      .d {\n        stroke-width: 3px;\n      }\n\n      .e {\n        stroke-dasharray: 11.664 11.664;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M83.071,855.905c-1.442-1.396-2.865-2.801-4.269-4.217"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M69.903,842.315c-16.325-17.991-29.783-37.484-40.075-58.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M27.058,778.058c-.832-1.818-1.641-3.646-2.426-5.485"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1305.869,774.745c-104.708,64.526-229.985,119.898-368.66,159.351-293.928,83.621-574.325,74.748-749.226-7.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1428.931,97.964c1.85.78,3.689,1.568,5.518,2.364"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1445.093,105.099c86.806,40.088,148.229,98.042,173.312,171.618"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1620.215,282.253c.596,1.905,1.168,3.821,1.716,5.747"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M424.47,206.109c83.063-42.205,175.674-78.713,275.184-107.023,221.595-63.043,435.5-73.514,602.306-39.485"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 133.635,
    cy: 893.932,
    rx: 26.725,
    ry: 26.003
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 1367.803,
    cy: 70.249,
    rx: 26.725,
    ry: 26.003
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1279.205,773.818c-99.406,58.079-215.791,107.936-343.547,144.282-290.864,82.749-568.478,74.923-743.723-5.224"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1262.194,774.154c-95.499,53.816-205.785,100.062-326.168,134.31-288.925,82.198-564.776,75.023-740.204-3.63"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M376.706,206.624c91.537-48.338,194.869-90.022,306.543-121.792,230.794-65.66,453.578-76.565,627.309-41.124"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M353.913,206.167c95.779-51.665,204.679-96.155,322.752-129.747C911.306,9.667,1137.803-1.421,1314.429,34.611"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionPageAccent);
export default __webpack_public_path__ + "static/media/missionPageAccent.97a36330be37579b1f280c12366e978c.svg";
export { ForwardRef as ReactComponent };